import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/lib/react';
import Image from 'next/image';
import EasySwipe from 'react-easy-swipe';
import { theme, Modal, Text, useBreakpoint, Link } from '@mtsbank/ui-kit';
import closeModal from '@asserts/images/cyber/closeModal.svg';
import { Spacer } from '@root/components/Uikit/Spacer';
import messageDark from '@asserts/images/cyber/messageDark.png';
import { InfoBannerIndividualOrder } from './InfoBannerIndividualOrder';
interface ModalBannerDoneProps {
  open: boolean;
  handleClose: () => void;
}
export const ModalIndividualOrder: FC<ModalBannerDoneProps> = ({
  open,
  handleClose
}) => {
  const [isClosing, setIsClosing] = useState(true);
  const [swipeDirection, setSwipeDirection] = useState('');
  const {
    isMobile
  } = useBreakpoint();
  const onSwipeStart = () => {
    setSwipeDirection('');
  };
  const onSwipeMove = position => {
    const direction = position.y > 0 ? 'up' : 'down';
    setSwipeDirection(direction);
  };
  const onSwipeEnd = () => {
    if (swipeDirection === 'up') {
      handleCloseModal();
    }
  };
  useEffect(() => {
    if (!open) return;
    setIsClosing(false);
  }, [open]);
  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      //   setIsClosing(false)
      handleClose();
    }, 400);
  };
  return <StyledModal isClosing={isClosing} open={open} onClose={isMobile ? handleCloseModal : handleClose} closeIcon={<Image priority src={closeModal} width={32} height={32} alt="close" />} size="md">
      <EasySwipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
        <Modal.Body>
          <Image priority src={messageDark} alt="repair" width={120} height={120} />
          <Spacer space={24} spacetablet={24} spacemob={24} />

          <Heading>Поможем оформить и&nbsp;оплатить любой сервис</Heading>

          <Spacer space={8} spacetablet={8} spacemob={8} />

          <Text color="#ADB0CC" align="center">
            Напишите на&nbsp;почту нашего партнера{' '}
            <NewCardLink href="mailto:help@shookru.com">help@shookru.com</NewCardLink>
          </Text>
          <Text color="#ADB0CC" align="center">
            Рассмотрим ваш вопрос и&nbsp;сообщим детали по&nbsp;заказу
          </Text>

          <Spacer space={24} spacetablet={24} spacemob={24} />
          <InfoBannerIndividualOrder title="Как написать нам письмо:" />
        </Modal.Body>
      </EasySwipe>
    </StyledModal>;
};
const StyledModal = /*#__PURE__*/styled(Modal)({
  name: "StyledModal",
  class: "skjkh3y",
  vars: {
    "skjkh3y-1": [({
      isClosing
    }) => isClosing ? 'translateY(100%)' : 'translateY(0)']
  }
});
const Heading = /*#__PURE__*/styled("div")({
  name: "Heading",
  class: "h7ah0qv"
});
const NewCardLink = /*#__PURE__*/styled(Link)({
  name: "NewCardLink",
  class: "n4nymkv"
});

require("./ModalIndividualOrder.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./ModalIndividualOrder.tsx");